import { Header } from "@/components/Header";

export function Placeholder({ title }: { title: string }) {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="mx-auto max-w-[720px] px-6 py-20">
        <h1 className="font-serif text-[36px] font-semibold">{title}</h1>
        <p className="mt-3 font-serif text-lg text-ink-2">Coming in the next phase.</p>
      </main>
    </div>
  );
}
